import { render, staticRenderFns } from "./ColorPickerMenu.vue?vue&type=template&id=409f2f32&"
import script from "./ColorPickerMenu.vue?vue&type=script&lang=js&"
export * from "./ColorPickerMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports